import React, { useState } from "react";
import axios from "axios";

const Signup = ({ setShowLogin, setShowSignup }) => {
  const [responseMessage, setResponseMessage] = useState("");

  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    pancard: "",
    category: "",
    pass: "",
    client_id: "",
    actual_parent_id: "",
    child_side: "",
    // address: "",
  });

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!/^\d+$/.test(formData.mobile)) {
      setError("Phone number must be numeric");
      return;
    }

    if (formData.pass.length < 4) {
      setError("Password must be at least 4 characters long");
      return;
    }

    try {
      // await axios.post("http://localhost:8094/api/signup", formData);
      await axios.post("https://api.swalokgroup.com/api/signup", formData);

      setResponseMessage("Signed in Successfully");
      setTimeout(() => {
        setResponseMessage("");
        setShowSignup(false);
        setShowLogin(true);
      }, 1000);
      setFormData({
        name: "",
        mobile: "",
        category: "",
        pass: "",
        client_id: "",
        actual_parent_id: "",
        child_side: "",
      });
    } catch (error) {
      setError(error.response.data);
    }
  };

  return (
    <>
      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Signin</span>
            <hr />
          </div>
          <p className="sec-heading">Create an Account</p>

          <div className="bg-body-tertiary px-4 py-5 mt-4 col-lg-6 col-md-10 col-12 mx-auto text-start">
            <form className="row g-3" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-input"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Your Name"
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="tel"
                  className="form-input"
                  name="mobile"
                  minLength={10}
                  maxLength={10}
                  value={formData.mobile}
                  placeholder="Your Phone"
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="tel"
                  className="form-input"
                  name="pancard"
                  minLength={10}
                  maxLength={10}
                  value={formData.pancard}
                  placeholder="Enter PAN"
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <select
                  className="form-input"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  required
                >
                  <option className="contact-input" value="" selected disabled>
                    Select Role
                  </option>
                  <option className="contact-input" value="Associate">
                    Associate
                  </option>
                  <option className="contact-input" value="Employee">
                    Employee
                  </option>
                </select>
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-input"
                  name="client_id"
                  value={formData.client_id}
                  onChange={handleInputChange}
                  placeholder="Your User Id"
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-input"
                  name="actual_parent_id"
                  value={formData.actual_parent_id}
                  onChange={handleInputChange}
                  placeholder="Referral Id"
                />
              </div>
              <div className="col-6">
                <input
                  type="password"
                  className="form-input"
                  name="pass"
                  value={formData.pass}
                  onChange={handleInputChange}
                  placeholder="Your Password"
                  required
                />
              </div>
              <div className="col-md-6">
                <select
                  className="form-input"
                  name="child_side"
                  value={formData.child_side}
                  onChange={handleInputChange}
                  required
                >
                  <option className="contact-input" value="" selected disabled>
                    Select Direction
                  </option>
                  <option className="contact-input" value="Left">
                    Left
                  </option>
                  <option className="contact-input" value="Right">
                    Right
                  </option>
                </select>
              </div>
              {error && <div className="text-danger">{error}</div>}
              <div className="col-12 my-4">
                <button type="submit" className="banner-btn w-100">
                  Sign In
                </button>
              </div>
            </form>
            {/* form ends */}
            <p className="text-center fst-italic">
              Already have an Account?{" "}
              <span
                className="toggle-link"
                onClick={() => {
                  setShowSignup(false);
                  setShowLogin(true);
                }}
              >
                Login
              </span>{" "}
              Here.
            </p>
          </div>
        </div>
      </section>

      {responseMessage && (
        <div className="response-message d-flex justify-content-between">
          <p className="my-0 mx-auto">{responseMessage}</p>
          <p
            className="my-0 cursor-pointer"
            onClick={() => setResponseMessage(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </p>
        </div>
      )}
    </>
  );
};

export default Signup;
